<div class="right-side p-5">
  <h2>Invoice Dashboard</h2>
  <div class="section">
    <form [formGroup]="form">

      <div class="row">
        <div class="text-end">
          <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
          <button (click)="exportToPDF()" type="button" class="btn btn-sm btn-primary">Export to PDF</button>
        </div>

        <div class="col-lg-7 col-sm-12">
          <mat-form-field class="search-input w-75" appearance="outline">
            <mat-label>Search</mat-label>
            <input matInput formControlName="searchControl" />
          </mat-form-field>
          <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form.get('searchControl')?.value ?? '')" id="btnSearch">
            <i class="bi bi-search fs-4"></i>
          </button>
          <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
            <i class="bi bi-arrow-clockwise fs-4"></i>
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="InvoiceStatus" matSort matSortDirection="asc" matSortDisableClear>
          <ng-container matColumnDef="Sr.No">
            <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
            <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
          </ng-container>
          <ng-container matColumnDef="InvoiceId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Number</th>
            <td mat-cell *matCellDef="let el" class="text-primary no-underline" style="cursor: pointer;" (click)="ViewInvoiceDetails(el.eventId)"> {{el.invoiceID}} </td>
          </ng-container>
          <ng-container matColumnDef="EventId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Event ID</th>
            <td mat-cell *matCellDef="let el"> {{el.eventId}} </td>
          </ng-container>
          <ng-container matColumnDef="NameOfOrganisation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name of Organisation</th>
            <td mat-cell *matCellDef="let el"> {{el.nameOfOrganisation}} </td>
          </ng-container>
          <ng-container matColumnDef="NameofEvent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name of Event</th>
            <td mat-cell *matCellDef="let el"> {{el.eventName}} </td>
          </ng-container>
          <ng-container matColumnDef="Intervention">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention</th>
            <td mat-cell *matCellDef="let el"> {{el.interventionName}} </td>
          </ng-container>
          <ng-container matColumnDef="Component">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Component</th>
            <td mat-cell *matCellDef="let el"> {{el.interestName}} </td>
          </ng-container>
          <ng-container matColumnDef="EventStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Status</th>
            <td mat-cell *matCellDef="let el"> {{el.eventStatus}} </td>
          </ng-container>
          <ng-container matColumnDef="InvoiceStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Status</th>
            <td mat-cell *matCellDef="let el"> {{el.invoiceStatus}} </td>
          </ng-container>
          <ng-container matColumnDef="NoOfMSMEAttended">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Total count of Verified MSME Attended</th>
            <td mat-cell *matCellDef="let el"> {{el.noOfMSMEAttended}} </td>
          </ng-container>
          <ng-container matColumnDef="RatePerMSME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Rate per MSME</th>
            <td mat-cell *matCellDef="let el"> {{el.ratePerMSME}} </td>
          </ng-container>
          <ng-container matColumnDef="Total">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total</th>
            <td mat-cell *matCellDef="let el"> {{el.total}} </td>
          </ng-container>
          <ng-container matColumnDef="GSTType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>GST Type</th>
            <td mat-cell *matCellDef="let el"> {{el.gstType}} </td>
          </ng-container>
          <ng-container matColumnDef="GSTPercent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>GST Percent</th>
            <td mat-cell *matCellDef="let el"> {{el.gstPercent}} </td>
          </ng-container>
          <!--<ng-container matColumnDef="IGST">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>IGST</th>
            <td mat-cell *matCellDef="let el"> {{el.igst}} </td>
          </ng-container>-->
          <ng-container matColumnDef="TotalGST">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total GST</th>
            <td mat-cell *matCellDef="let el"> {{el.totalGST}} </td>
          </ng-container>
          <ng-container matColumnDef="FinalTotal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Final Total</th>
            <td mat-cell *matCellDef="let el"> {{el.finalTotal}} </td>
          </ng-container>
          <ng-container matColumnDef="PaymentDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Date</th>
            <td mat-cell *matCellDef="let el"> {{el.paymentDate}} </td>
          </ng-container>
          <ng-container matColumnDef="Mode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Mode</th>
            <td mat-cell *matCellDef="let el"> {{el.mode}} </td>
          </ng-container>
          <ng-container matColumnDef="UTRNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>UTR Number</th>
            <td mat-cell *matCellDef="let el"> {{el.utrNumber}} </td>
          </ng-container>
          <ng-container matColumnDef="AmountPaid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount paid by department</th>
            <td mat-cell *matCellDef="let el"> {{el.amountPaid}} </td>
          </ng-container>         
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let el">
              <button class="btn btn-primary btn-sm mx-1 mt-1 mb-1" (click)="openFilePreviewDialog(el.invoiceFileName,el.invoiceFilePath)"> <i class="bi bi-eye"></i> View Uploaded Invoice</button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          Row shown when there is no matching data.
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter</td>

          </tr>
        </table>

      </div>
      <mat-paginator #paginator
                     class="demo-paginator"
                     (page)="onPageChange($event)"
                     [length]="length"
                     [pageSize]="pageSize"
                     [showFirstLastButtons]="showFirstLastButtons"
                     [pageSizeOptions]="pageSizeOptions"
                     [hidePageSize]="hidePageSize"
                     [pageIndex]="pageIndex"
                     aria-label="Select page">
      </mat-paginator>

    </form>

  </div>


</div>



